import { preferredLanguageAtom } from '@openeducation/oe-rn-jotai-atoms';
import { LanguagesService } from '@openeducation/oe-rn-services';
import type { Language } from '@openeducation/oe-rn-shared-types';
import { useSetAtom } from 'jotai';
import { useEffect } from 'react';
import { useQuery } from 'react-query';

import { useEnvironmentContext } from '../environment/environment.provider';

export const useGetLocalLanguage = (
  getLanguageByLocalization: (supportedLanguages: Language[]) => Language
) => {
  const setLanguageAtom = useSetAtom(preferredLanguageAtom);
  const { environment } = useEnvironmentContext();
  const { data: supportedLanguageCodes, isLoading: isLocalLanguageLoading } =
    useQuery<Language[]>('supportedLanguageCodes', () =>
      LanguagesService.getSupportedLanguageCodes(environment)
    );

  useEffect(() => {
    if (supportedLanguageCodes) {
      const localLanguage = getLanguageByLocalization(supportedLanguageCodes);
      setLanguageAtom(localLanguage);
    }
  }, [supportedLanguageCodes, setLanguageAtom, getLanguageByLocalization]);

  return { isLocalLanguageLoading };
};
